/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: 'UA-174238252-2',
};

//Home Page
const greeting = {
  title: 'Hello 👋.',
  title2: 'Allen Jones',
  logo_name: 'JonesDev',
  nickname: 'Allen Jones',
  full_name: 'Allen Jones',
  subTitle:
    'Software engineer and a passionate computer programmer 🔥. I love computer programming',
  resumeLink: 'https://drive.google.com/file/d/1MmiougWdRec4S3D1j-7nC9-WBqLvMrXT/view?usp=sharing',
  mail: 'mailto:aljay3334@gmail.com',
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: 'https://github.com/allenarduino',
  linkedin: 'https://www.linkedin.com/in/allen-jones-b799b7171/',
  gmail: 'aljay3334@gmail.com',
  gitlab: 'https://gitlab.com/allenarduino',
  facebook: 'https://wwww.facebook.com/profile.php?id=100021937291259',
  twitter: 'https://twitter.com/allenjones126?s=09',
  instagram: 'https://www.instagram.com/_allenjones/',
};

const skills = {
  data: [
    {
      title: 'Full Stack Development',
      fileName: 'FullStackImg',
      skills: [
        '⚡ Developing single page websites using ReactJs and AngularJs',
        '⚡ Building responsive website front end using ReactJS and Bootstrap',
        '⚡ Developing mobile applications using  React Native',
        '⚡ Creating application backend REST API in core PHP,Flask and NodeJS',
        '⚡ Integration of third party services such as Firebase',
        '⚡ Using MySQL  for database of app',
      ],
      softwareSkills: [
        {
          skillName: 'HTML5',
          fontAwesomeClassname: 'simple-icons:html5',
          style: {
            color: '#E34F26',
          },
        },
        {
          skillName: 'CSS3',
          fontAwesomeClassname: 'fa-css3',
          style: {
            color: '#1572B6',
          },
        },
        {
          skillName: 'JavaScript',
          fontAwesomeClassname: 'simple-icons:javascript',
          style: {
            backgroundColor: '#FFFFFF',
            color: '#F7DF1E',
          },
        },
        {
          skillName: 'PHP',
          fontAwesomeClassname: 'simple-icons:php',
          style: {
            color: '#7377AD',
          },
        },
        {
          skillName: 'ReactJS',
          fontAwesomeClassname: 'simple-icons:react',
          style: {
            color: '#61DAFB',
          },
        },
        {
          skillName: 'NodeJS',
          fontAwesomeClassname: 'simple-icons:node-dot-js',
          style: {
            color: '#339933',
          },
        },
        {
          skillName: 'NPM',
          fontAwesomeClassname: 'simple-icons:npm',
          style: {
            color: '#CB3837',
          },
        },
        /*{
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },*/
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        /* {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },*/
        {
          skillName: 'Java',
          fontAwesomeClassname: 'simple-icons:java',
          style: {
            color: '#f89820',
          },
        },
        /* {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },*/
        /*  {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },*/
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        {
          skillName: 'MySQL',
          fontAwesomeClassname: 'simple-icons:mysql',
          style: {
            color: '#4479A1',
          },
        },
        {
          skillName: 'jQuery',
          fontAwesomeClassname: 'simple-icons:jquery',
          style: {
            color: '#0865A6',
          },
        },
        /* {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },*/
        {
          skillName: 'Apache',
          fontAwesomeClassname: 'simple-icons:apache',
          style: {
            color: '#CA1A22',
          },
        },
        {
          skillName: 'Git',
          fontAwesomeClassname: 'simple-icons:git',
          style: {
            color: '#E94E32',
          },
        },
        /* {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },*/
        /*  {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },*/
        {
          skillName: 'Python',
          fontAwesomeClassname: 'simple-icons:python',
          style: {
            color: '#3776AB',
          },
        },
      ],
    },
    {
      title: 'Cloud Infra-Architecture',
      fileName: 'CloudInfraImg',
      skills: [
        '⚡ Experience working on multiple cloud platforms',
        '⚡ Experience hosting and managing websites',
        '⚡ Experience with Continuous Integration',
      ],
      softwareSkills: [
        /* {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },*/
        {
          skillName: 'Netlify',
          fontAwesomeClassname: 'simple-icons:netlify',
          style: {
            color: '#38AFBB',
          },
        },
        {
          skillName: 'Heroku',
          fontAwesomeClassname: 'simple-icons:heroku',
          style: {
            color: '#6863A6',
          },
        },
        {
          skillName: 'Firebase',
          fontAwesomeClassname: 'simple-icons:firebase',
          style: {
            color: '#FFCA28',
          },
        },
        {
          skillName: 'PostgreSQL',
          fontAwesomeClassname: 'simple-icons:postgresql',
          style: {
            color: '#336791',
          },
        },
        /* {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },*/
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: 'Kwame Nkrumah University of Science and Technology',
      subtitle: 'BSC. Computer Engineering',
      logo_path: 'ssgandhy.png',
      alt_name: 'SETI',
      duration: '2017 - 2021',
      descriptions: [
        '⚡ I have studied courses like Data Structures, DBMS, Networking, Security, etc.',
        '⚡ I have also completed various online courses on web development',
        "⚡ I have implemented several projects based on what I've learnt online and in school ",
      ],
      website_link: 'http://knust.edu.gh/',
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: 'Introduction To Packet Tracer',
      subtitle: 'CISCO',
      logo_path: 'packet_tracer.png',
      color_code: '#2AAFED',
    },

    {
      title: 'PHP Tutorial',
      subtitle: 'SOLO LEARN',
      logo_path: 'PHP_certificate.jpg',
      color_code: '#F6B808',
    },
    {
      title: 'Java Tutorial',
      subtitle: 'SOLO LEARN',
      logo_path: 'Java_certificate.jpg',
      color_code: '#2AAFED',
    },
    {
      title: 'JavaScript Tutorial',
      subtitle: 'SOLO LEARN',
      logo_path: 'JavaScript_certificate.jpg',
      color_code: '#fe0037',
    },
    {
      title: 'SQL Fundamentals',
      subtitle: 'SOLO LEARN',
      logo_path: 'SQL_certificate.jpg',
      color_code: '#2AAFED',
    },
    /* {
      title: "Postman Student Expert",
      subtitle: "Postman",
      logo_path: "postman.png",
      certificate_link:
        "https://badgr.com/public/assertions/h2qevHs4SlyoHErJQ0mn2g",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },*/
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: 'Experience',
  subtitle: 'Work, Internship and Volunteership',
  description:
    "I'm currently a Frontend Engineer at Asqii LLC. I love organizing workshops to share my knowledge with others.",
  header_image_path: 'experience.svg',
  sections: [
    {
      title: 'Work Experience',
      experiences: [
        {
          title: 'Frontend Engineer (React and React Native)',
          company: 'Asqii LLC',
          logo_path: 'asqii-logo.png',
          duration: 'Oct 2021 - Present',
          location: 'Remote',
          description:
            'Currently working on the admin panel and the mobile applications of a decentralized school management system',
          color: '#0071C5',
        },
        {
          title: 'Full Stack Developer (Intern)',
          company: 'aPavone Concepts',
          company_url: 'https://apavone.com/',
          logo_path: 'apavone-logo.png',
          duration: 'July 2020 - Jan 2021',
          location: 'Remote',
          description:
            'Worked on an E-commerce website for selling religious items like bible,comminion,quoran and many more',
          color: '#0071C5',
        },
      ],
    },
    /*
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Cross Winter of Code Mentor",
          company: "CWOC",
          company_url: "https://crosswoc.ieeedtu.in/",
          logo_path: "cwoc.png",
          duration: "Feb 2021 - Present",
          location: "Work From Home",
          description:
            "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
          color: "#4285F4",
        },
        {
          title: "Campus Hustler",
          company: "Skillenza",
          company_url: "https://skillenza.com/",
          logo_path: "skillenza.png",
          duration: "Feb 2021 - Present",
          location: "Work from Home",
          description: "Spread Awareness of new Technologies and new Opportunities to Students and Grow Skillenza Community.",
          color: "#196acf",
        },
        {
          title: "GitHub Student Developer",
          company: "GitHub",
          company_url: "https://github.com/",
          logo_path: "github.png",
          duration: "Nov 2019 - Present",
          location: "Work from Home",
          description:
          "Contribute to Open Source Community and Open Source Project.",
          color: "#040f26",
        },
        {
          title: "Google Local Guide",
          company: "Google Map",
          company_url: "https://maps.google.com/localguides/",
          logo_path: "localguide.png",
          duration: "Sep 2018 - Present",
          location: "Work From Home",
          description:
            "Day-to-day responsibilities of helping local businesses to spread their business to the world. Helping users by writing reviews about different locations and spaces such as shops, malls, etc.",
          color: "#D83B01",
        },
        {
          title: "GDG Student Volunteer",
          company: "Google Developer Groups",
          company_url: "https://gdg.community.dev/",
          logo_path: "gdg.png",
          duration: "Feb 2021 - Present",
          location: "Work From Home",
          description:
            "Google Developer Group Surat Student Volunteer and Member.",
          color: "#D83B01",
        },
        {
          title: "E. F. I. Student Volunteer",
          company: "ENVIRONMENTALIST FOUNDATION OF INDIA",
          company_url: "https://indiaenvironment.org/",
          logo_path: "efi.png",
          duration: "Apr 2017 - Present",
          location: "Work From Home",
          description:
            "Take time out over weekends to join a gang of nation builders, nature enthusiasts to conserve what is left.",
          color: "#5a900f",
        },
      ],
    },*/
  ],
};

// Projects Page
const projectsHeader = {
  title: 'Projects',
  description:
    'My projects make use of a vast variety of latest technology tools. My best experience is to create  Backend REST APIs, Python Scripts, React Projects and Front end of apps. Below are some of my projects.',
  avatar_image_path: 'projects_image.svg',
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: 'Contact Me',
    profile_image_path: 'allen.jpg',
    description:
      'You can contact me on the social media platforms below. I will try to get back to you as fast as I can. ',
  },
  blogSection: {
    title: 'Blogs',
    link: 'https://twitter.com/allenjones126?s=09',
    subtitle:
      "I don't blog frequently but when I do something awesome, I will document it so it can be helpful to others.",
    avatar_image_path: 'blogs_image.svg',
  },
};

const projects = {
  data: [
    {
      id: '0',
      name: 'Kelly Foods',
      url: 'https://kelly-foods.web.app',
      description:
        'Kelly Foods is an online food delivery and reservation system that enables users to easily order for their favourite dishes or book a table.',
      languages: [
        {
          name: 'Flask',
          iconifyClass: 'logos-flask',
        },

        {
          name: 'MySQL',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '1',
      name: 'Demorto Foods',
      url: 'https://demorto-foods.web.app',
      description:
        'A website for an ice cream making workshop organized by Demorto Foods. A ticket is generated for a user after payment and registration is done.',
      languages: [
        {
          name: 'NodeJs',
          iconifyClass: 'logos-nodejs',
        },

        {
          name: 'MySQL',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '2',
      name: 'Jones Mall',
      url: 'https://jones-mall.web.app',
      description:
        'A single vendor E-commerce web application powered by NodeJs,React and MongoDB. It has an admin panel for the vendor and a website for customers.',
      languages: [
        {
          name: 'NodeJs',
          iconifyClass: 'logos-nodejs',
        },

        {
          name: 'MySQL',
          iconifyClass: 'logos-mongodb',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '2',
      name: 'Merllon Social',
      url: 'https://github.com/allenarduino/merllon_social',
      description:
        "Online social media app for sharing of images,videos and text posts.A user can create a post,like a post,edit his or her profile or comment on other people's posts.",
      languages: [
        {
          name: 'NodeJs',
          iconifyClass: 'logos-nodejs',
        },

        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '2',
      name: 'Teklife',
      url: 'https://github.com/allenarduino/Node_Social',
      description:
        'React Native and NodeJs social media  mobile app. It has buy and sell feature too. Please visit the repository to see the screenshots.',
      languages: [
        {
          name: 'NodeJs',
          iconifyClass: 'logos-nodejs',
        },

        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '2',
      name: 'Allen Chat',
      url: 'https://github.com/allenarduino/Allenchat',
      description: 'React Native and NodeJs chatting mobile app.',
      languages: [
        {
          name: 'NodeJs',
          iconifyClass: 'logos-nodejs',
        },

        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
      ],
    },

    {
      id: '3',
      name: 'Wapp',
      url: 'https://github.com/allenarduino/preschool',
      description:
        'An Online E-learning or Prep app for high school students.Multiple instructors can create a courses for students to enroll in.',
      languages: [
        {
          name: 'Python',
          iconifyClass: 'logos-python',
        },
        {
          name: 'Flask',
          iconifyClass: 'cib-flask',
        },
        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
      ],
    },

    {
      id: '4',
      name: 'Propertyn',
      url: 'https://propertyn-b454c.web.app/',
      description:
        'An Online Property management or property insurance system built for a hackathon competition.',
      languages: [
        {
          name: 'Python',
          iconifyClass: 'logos-python',
        },
        {
          name: 'Flask',
          iconifyClass: 'cib-flask',
        },
        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
      ],
    },

    {
      id: '4',
      name: 'Merllon',
      url: 'https://merllon-47c6e.web.app/',
      description: `A simple social image sharing web application. 
        A user can share an image,edit his/her profile or comment on other people's posts.`,
      languages: [
        {
          name: 'Python',
          iconifyClass: 'logos-python',
        },
        {
          name: 'Flask',
          iconifyClass: 'cib-flask',
        },
        {
          name: 'MySQL Database',
          iconifyClass: 'logos-mysql',
        },
        {
          name: 'React',
          iconifyClass: 'logos-react',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
      ],
    },

    {
      id: '5',
      name: 'MerllonJones',
      url: 'https://merllonjones-f997d.firebaseapp.com',
      description: 'MerllonJones is a simple online CV.',
      languages: [
        {
          name: 'JavaScript',
          iconifyClass: 'logos-javascript',
        },
        {
          name: 'Python',
          iconifyClass: 'logos-python',
        },
        {
          name: 'Flask',
          iconifyClass: 'cib-flask',
        },
        {
          name: 'HTML',
          iconifyClass: 'vscode-icons:file-type-html',
        },
        {
          name: 'Bootstrap',
          iconifyClass: 'logos-bootstrap',
        },

        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
      ],
    },

    {
      id: '6',
      name: 'flask_forum',
      url: 'https://github.com/allenarduino/flask_forum',
      description: 'Simple online forum for sharing images together with quetions.',
      languages: [
        {
          name: 'JavaScript',
          iconifyClass: 'logos-javascript',
        },
        {
          name: 'HTML',
          iconifyClass: 'vscode-icons:file-type-html',
        },
        {
          name: 'Bootstrap',
          iconifyClass: 'logos-bootstrap',
        },

        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
